.container {
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 10px;
}